import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { ResponsiveCommandSelect } from "@/components/ui/responsive-select";
import type { Control } from "react-hook-form";
import type { MeetingFormValues } from "../../types/meeting-form";

interface MeetingTypeAndStatusProps {
  control: Control<MeetingFormValues>;
  isSubmitting: boolean;
  meetingTypeOptions: Array<{ value: string; label: string }>;
  statusOptions: Array<{ value: string; label: string }>;
}

export const MeetingTypeAndStatusFields: React.FC<MeetingTypeAndStatusProps> = ({ 
  control, 
  isSubmitting,
  meetingTypeOptions,
  statusOptions
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <FormField
      control={control}
      name="meeting_type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Meeting Type</FormLabel>
          <FormControl>
            <ResponsiveCommandSelect
              value={field.value}
              onValueChange={field.onChange}
              options={meetingTypeOptions}
              disabled={isSubmitting}
              title="Meeting Type"
              description="Select the type of meeting"
              placeholder="Select meeting type"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />

    <FormField
      control={control}
      name="status"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Status</FormLabel>
          <FormControl>
            <ResponsiveCommandSelect
              value={field.value}
              onValueChange={field.onChange}
              options={statusOptions}
              disabled={isSubmitting}
              title="Meeting Status"
              description="Current status of the meeting"
              placeholder="Select status"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  </div>
);
